export default {
  items: [
    {
      title: true,
      name: 'Administracion'
    },
    {
      name: 'Distribuidores',
      url: '/distribuidores',
      icon: 'fa fa-user'
    },
    {
      name: 'Contribuyentes',
      url: '/contribuyentes',
      icon: 'fa fa-users'
    },
    {
      name: 'Compras',
      url: '/compras',
      icon: 'fa fa-tags'
    },
    {
      name: 'Asignaciones',
      url: '/asignaciones',
      icon: 'fa fa-book'
    },
    {
      name: 'Asignaciones Esp',
      url: '/asignaciones-especiales',
      icon: 'fa fa-book'
    },
    {
      name: 'Asignaciones Esp 2',
      url: '/asignaciones-especiales-2',
      icon: 'fa fa-book'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js